import { render } from "./PaquetesWeb.vue?vue&type=template&id=02bc2b2c"
import script from "./PaquetesWeb.vue?vue&type=script&lang=js"
export * from "./PaquetesWeb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__